// export const baseUrl = 'http://localhost:5002'
// export const baseUrl = 'https://xerox-hub-backend.onrender.com'
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;


console.log({baseUrl}, process.env)

export const loginUrl = baseUrl + '/vendors/login';

export const otpRequestUrl = baseUrl + '/vendors/otp-request';
export const sendOtpRequestUrl = baseUrl + "/otp/send";

export const vendorsUrl = baseUrl + '/user';
export const deliverySlotsUrl = baseUrl + '/delivery-slots/';
export const paymentMethodsUrl = baseUrl + '/payment-methods/';

// Print Requests Urls
export const printRequestsUrl = baseUrl + '/print-requests';
export const printRequestsTodayUrl = printRequestsUrl + '/today';
export const printRequestUpdateStatusUrl = printRequestsUrl + '/status';

export const storesUrl = baseUrl + '/stores';

// Add the new user search URL
export const getUserByCognitoIdUrl = (cognitoId) =>
  `${baseUrl}/user/${cognitoId}`;
export const updateUserByCognitoIdUrl = getUserByCognitoIdUrl;
export const deleteUserByCognitoIdUrl = (cognitoId) =>
  `${baseUrl}/user/${cognitoId}`;

// Team member APIs
export const teamMemberUrl = baseUrl + '/user/teams';
export const addTeamMemberUrl = baseUrl + '/user/team-member';

// Service Urls
export const servicesUrl = baseUrl + '/services'
export const getServiceConfigsByStoreIdUrl = (storeId) => `${baseUrl}/service-configs/store/${storeId}`; // GET

export const createServiceConfigUrl = baseUrl + '/service-configs'; // POST
export const getServiceConfigByIdUrl = (id) => `${baseUrl}/service-configs/${id}`; // GET
export const updateServiceConfigUrl = (id) => `${baseUrl}/service-configs/${id}`; // PATCH
export const deleteServiceConfigUrl = (id) => `${baseUrl}/service-configs/${id}`; // DELETE

